import * as React from 'react';
import styled from 'styled-components';
import { lighten } from 'polished';
import * as CloseIcon from 'react-icons/lib/io/close-round';
import colors from '../colors';
import { Banner as BannerT } from '../../typedefs/store';

interface Props {
    banners: BannerT[];
    shouldShow: boolean;
    style?: any;
    hide: () => void;
}
interface State {}

class Banner extends React.Component<Props, State> {
    close = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.hide();
    };

    render() {
        if (this.props.shouldShow === false || this.props.banners.length === 0) return null;

        return (
            <Wrapper className="conversations-banner" style={this.props.style}>
                <BannerTextWrapper className="conversations-banner-title" href={this.props.banners[0].url}>
                    {this.props.banners[0].banner}
                </BannerTextWrapper>
                <BannerIconWrapper className="conversations-banner-close" href="#" onClick={this.close}>
                    <CloseIcon size={12} />
                </BannerIconWrapper>
            </Wrapper>
        );
    }
}

export default Banner;

const Wrapper = styled.div`
    background-color: ${colors.darkBlue};
    padding: 10px 15px;
    color: white;
    display: flex;
    &:hover {
        background-color: ${props => lighten(0.05, colors.darkBlue)};
    }
`;

const BannerTextWrapper = styled.a`
    display: block;
    flex-grow: 1;
    color: white;
    &:hover {
        color: white;
    }
    text-decoration: none;
`;

const BannerIconWrapper = styled.a`
    display: block;
    flex-grow: 0;
    flex-shrink: 0;
    color: white;
    &:hover {
        color: white;
    }
    margin-left: 10px;
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/Banner.tsx